(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sw-quote-request"] && !Shopify.designMode) return;
  try {
    (function () {
    function update(form) {
      var boxes = Array.prototype.slice.call(form.querySelectorAll('input[data-sw-topic]'));
      if (!boxes.length) return;
      var picked = boxes.filter(function (b) { return b.checked; });
      var keys = picked.map(function (b) { return b.getAttribute('data-sw-topic'); });

      var value = form.querySelector('[data-sw-topics-value]');
      if (value) value.value = picked.map(function (b) { return b.value; }).join(', ');
      boxes[0].setCustomValidity(picked.length ? '' : 'Please choose at least one option.');

      form.querySelectorAll('[data-sw-branch]').forEach(function (branch) {
        var show = keys.indexOf(branch.getAttribute('data-sw-branch')) !== -1;
        branch.hidden = !show;
        branch.disabled = !show;
      });

      var unsure = form.querySelector('[data-sw-unsure]');
      var size = form.querySelector('[data-sw-size]');
      if (unsure && size) {
        size.disabled = unsure.checked;
        size.classList.toggle('is-off', unsure.checked);
      }

      var needNotes = keys.indexOf('other') !== -1;
      var notes = form.querySelector('textarea[name="contact[body]"]');
      var flag = form.querySelector('[data-sw-notes-flag]');
      if (notes) notes.required = needNotes;
      if (flag) flag.textContent = needNotes ? '(tell us what you need) *' : '(optional)';
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[data-sw-topic], input[data-sw-unsure]')) return;
      var form = input.closest('form[data-sw-quote]');
      if (form) update(form);
    });

    function init() {
      document.querySelectorAll('form[data-sw-quote]').forEach(update);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
